import { AdminNavbar } from "./AdminNavbar.jsx";

// Keep navigation available while each page loads or displays an error.
export const AdminLayout = ({ children }) => (
  <div className="admin-layout">
    <a className="admin-skip-link" href="#admin-workspace">Skip to content</a>
    <AdminNavbar />
    <div id="admin-workspace" className="admin-workspace" tabIndex={-1}>{children}</div>
  </div>
);
